import React, { useState, useEffect } from 'react';

function Header({ reservationEnabled, seasonalEnabled }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const section = document.querySelector(sectionId);
    if (section) {
      const headerHeight = document.querySelector('.header').offsetHeight;
      const targetPosition = section.offsetTop - headerHeight;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <a href="#hero" className="logo" onClick={(e) => scrollToSection(e, '#hero')}>
            <img src="/images/logo_req.jpg" alt="よし鮨" className="logo-img" />
          </a>
          <button 
            className="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <nav className={`nav ${isMobileMenuOpen ? 'open' : ''}`}>
            <ul>
              {seasonalEnabled && (
                <li><a href="#seasonal" onClick={(e) => scrollToSection(e, '#seasonal')}>旬</a></li>
              )}
              <li><a href="#menu" onClick={(e) => scrollToSection(e, '#menu')}>メニュー</a></li>
              <li><a href="#kodawari" onClick={(e) => scrollToSection(e, '#kodawari')}>こだわり</a></li>
              <li><a href="#store" onClick={(e) => scrollToSection(e, '#store')}>店舗情報</a></li>
              <li><a href="#schedule" onClick={(e) => scrollToSection(e, '#schedule')}>カレンダー</a></li>
              {reservationEnabled && (
                <>
                  <li><a href="#reservation" onClick={(e) => scrollToSection(e, '#reservation')}>オンライン予約</a></li>
                  <li><a href="#reservation-management" onClick={(e) => scrollToSection(e, '#reservation-management')}>予約確認</a></li>
                </>
              )}
              <li><a href="#access" onClick={(e) => scrollToSection(e, '#access')}>アクセス</a></li>
              <li><a href="#contact" onClick={(e) => scrollToSection(e, '#contact')}>お問い合わせ</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;

